import type { Styles } from "react-modal";

/**
 * Shared react-modal overlay/content styling. Typed as react-modal's own
 * `Styles` so consumers converted to TypeScript type-check against it.
 *
 * The content block used to carry `overflowX: "none"`, which is not a valid
 * value for that property — browsers dropped the declaration, so removing it
 * changes nothing at runtime. `overflowY: "auto"` already makes the computed
 * `overflow-x` auto, which is the behaviour that has always shipped.
 */
export const modalCss: Styles = {
  overlay: {
    WebkitTransform: "translate3d(0, 0, 0)",
    transform: "translate3d(0, 0, 0)",
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 985,
    opacity: ".99",
    backgroundColor: "rgba(37, 48, 49, 0.9)",
  },
  content: {
    WebkitTransform: "translate3d(0, 0, 0)",
    position: "absolute",
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    border: "1px solid #ccc",
    background: "#fff",
    overflowY: "auto",
    maxHeight: "90vh",
    maxWidth: "95vw",
    WebkitOverflowScrolling: "touch",
    borderRadius: "4px",
    outline: "none",
    padding: "20px",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    zIndex: 981,
  },
};
